
class Hash {
	constructor() {
		this.values = []
	}

	add(value) {
		this.values.push(value)
	}

	remove(value) {
		let index = this._findIndex(value)
		if (index >= 0) {
			this.values.splice(index, 1)
		}
	}

	has(value) {
		return this._findIndex(value) >= 0
	}

	_findIndex(value) {
		return this.values.findIndex(item => item === value)
	}

	size() {
		return this.values.length
	}

	list() {
		return this.values
	}
}

export default Hash
